import * as React from 'react';
import { ENV } from '~/common/enums/enums';
import { footerPayload, headerPayload } from '~/common/payload/payload';
import { Layout } from '~/components/common/common';
import { Join, Events, BSADescription } from '~/components/sections/sections';
import {
  joinPayload,
  eventsPayload,
  bsaDescriptionPayload,
  seoPayload,
} from './data/data';

const Page: React.FC = () => (
  <Layout
    seoPayload={seoPayload}
    headerPayload={headerPayload}
    footerPayload={footerPayload}
    registrationLink={ENV.APP.REGISTRATION_LINK}
  >
    <h1 className="visually-hidden">Online events</h1>
    <Events payload={eventsPayload} />
    <BSADescription payload={bsaDescriptionPayload} />
    <Join payload={joinPayload} registrationLink={ENV.APP.REGISTRATION_LINK} />
  </Layout>
);

export { Page };
